import { ServiceIncidentType } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'service-incident-type';

export class ServiceIncidentTypeController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findAll(): Promise<ServiceIncidentType[]> {
    const response = await this.http.get<ServiceIncidentType[]>('');
    return response.data.map((val) => new ServiceIncidentType(val));
  }
}
